import { render, staticRenderFns } from "./KeyFiguresPage.vue?vue&type=template&id=25492182&"
import script from "./KeyFiguresPage.vue?vue&type=script&lang=js&"
export * from "./KeyFiguresPage.vue?vue&type=script&lang=js&"
import style0 from "./KeyFiguresPage.vue?vue&type=style&index=0&id=25492182&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports